export enum TooltipTheme {
  Standard = 'Standard',
  Yellow = 'Yellow',
}
